import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function NotFound() {
  const { lang } = useI18n();
  return (
    <div className="container-x py-32 text-center">
      <div className="font-display text-8xl font-black text-primary">404</div>
      <h1 className="font-display text-2xl font-bold mt-4">{lang === "de" ? "Seite nicht gefunden" : "Page not found"}</h1>
      <p className="text-muted-foreground mt-3">{lang === "de" ? "Die angeforderte Seite existiert nicht." : "The requested page does not exist."}</p>
      <Link to="/" className="btn-primary mt-8" data-testid="notfound-home">{lang === "de" ? "Zur Startseite" : "Back home"}</Link>
    </div>
  );
}
